<template>
  <div class="page-meathuman">
    <!-- PC -->
    <div class="pc-wrap" v-if="!isMobile">
      <div class="logo-menu clearfix">
        <router-link class="logo" to="/">
          <img class="logo-img" src="./image/pc/logo.png" alt="" />
        </router-link>
        <div class="menu clearfix">
          <div class="menu-tit"><a href="javascript:;">虚拟数字资产</a></div>
          <div class="menu-tit"><a href="javascript:;">虚拟数字人类型</a></div>
          <div class="menu-tit"><a href="javascript:;">内容生产</a></div>
          <div class="menu-tit"><a href="javascript:;">应用场景</a></div>
          <div class="menu-tit"><a href="javascript:;">数字人发展简介</a></div>
          <div class="menu-tit"><a href="javascript:;">咨询服务</a></div>
        </div>
      </div>

      <div class="top-banner">
        <img class="show-img" src="./image/pc/banner.png" alt="" />
        <div class="btns clearfix">
          <a class="btn con-bot" href="javascript:;">业务咨询</a>
          <!-- <a class="btn white" href="javascript:;">在线咨询</a> -->
        </div>
      </div>

      <div class="one-site" id="scroll1">
        <div class="tit">一站式打造品牌虚拟数字资产</div>
        <div class="desc">超视界影视传媒在优化整合自有资源、发挥快速动画制作技术优势的基础上，全力打造出具有全场景、一站式、平台化特点的全链路定制服务模式，能满足从基础数字人形象设计、人设管理再到业务编排、内容创作，最后到多种驱动模式下与用户互动的全部需求。</div>
        <div class="swiper site-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide"><img class="img" src="./image/pc/step1.png" alt="" /></div>
            <div class="swiper-slide"><img class="img" src="./image/pc/step2.png" alt="" /></div>
            <div class="swiper-slide"><img class="img" src="./image/pc/step3.png" alt="" /></div>
            <div class="swiper-slide"><img class="img" src="./image/pc/step4.png" alt="" /></div>
            <div class="swiper-slide"><img class="img" src="./image/pc/step5.png" alt="" /></div>
            <div class="swiper-slide"><img class="img" src="./image/pc/step6.png" alt="" /></div>
            <div class="swiper-slide"><img class="img" src="./image/pc/step7.png" alt="" /></div>
          </div>
          <div class="site-control">
            <img class="con prev" src="./image/pc/site_arrow_left.png" alt="" />
            <img class="con next" src="./image/pc/site_arrow_right.png" alt="" />
          </div>
        </div>
      </div>

      <div class="swiper types-wrap clearfix" id="scroll2">
        <div class="swiper-wrapper">
          <div class="swiper-slide"><img class="img" src="./image/pc/type_img1.png" alt="" /></div>
          <div class="swiper-slide"><img class="img" src="./image/pc/type_img2.png" alt="" /></div>
          <div class="swiper-slide"><img class="img" src="./image/pc/type_img3.png" alt="" /></div>
          <div class="swiper-slide"><img class="img" src="./image/pc/type_img4.png" alt="" /></div>
          <div class="swiper-slide"><img class="img" src="./image/pc/type_img5.png" alt="" /></div>
        </div>
        <div class="types-list">
          <div class="tip">TYPE</div>
          <div class="tit">虚拟数字人类型</div>
          <div class="tp-list"></div>
        </div>
      </div>

      <!-- 内容生产 -->
      <div class="cont-pro" id="scroll3">
        <div class="sec-tit"><img class="img" src="./image/pc/sectit_cont_pro.png" alt="" /></div>
        <div class="tab-select-wrap">
          <div class="select-tab clearfix">
            <div class="tab-item">
              <img class="tab-img def" src="./image/pc/select_tab1.png" alt="" />
              <img class="tab-img act" src="./image/pc/select_tab1_active.png" alt="" />
              <div class="tab-tit">图片</div>
            </div>
            <div class="tab-item">
              <img class="tab-img def" src="./image/pc/select_tab2.png" alt="" />
              <img class="tab-img act" src="./image/pc/select_tab2_active.png" alt="" />
              <div class="tab-tit">直播</div>
            </div>
            <div class="tab-item">
              <img class="tab-img def" src="./image/pc/select_tab3.png" alt="" />
              <img class="tab-img act" src="./image/pc/select_tab3_acitve.png" alt="" />
              <div class="tab-tit">视频</div>
            </div>
            <div class="tab-item">
              <img class="tab-img def" src="./image/pc/select_tab4.png" alt="" />
              <img class="tab-img act" src="./image/pc/select_tab4_active.png" alt="" />
              <div class="tab-tit">语音</div>
            </div>
          </div>
        </div>
        <div class="cont-select-wrap">
          <!-- 图片 -->
          <div class="wrap-container">
            <div class="swiper cont-select-item">
              <div class="swiper-wrapper">
                <div class="swiper-slide im-wrap clearfix">
                  <div class="im-column-item">
                    <img class="two-img" src="./image/pc/im1.png" alt="" />
                    <img class="two-img" src="./image/pc/im2.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="one-img" src="./image/pc/im3.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="one-img" src="./image/pc/im4.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="two-img" src="./image/pc/im5.png" alt="" />
                    <img class="two-img" src="./image/pc/im6.png" alt="" />
                  </div>
                </div>
                <div class="swiper-slide im-wrap clearfix">
                  <div class="im-column-item">
                    <img class="one-img" src="./image/pc/im3.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="two-img" src="./image/pc/im1.png" alt="" />
                    <img class="two-img" src="./image/pc/im2.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="one-img" src="./image/pc/im4.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="two-img" src="./image/pc/im5.png" alt="" />
                    <img class="two-img" src="./image/pc/im6.png" alt="" />
                  </div>
                </div>
                <div class="swiper-slide im-wrap clearfix">
                  <div class="im-column-item">
                    <img class="one-img" src="./image/pc/im3.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="two-img" src="./image/pc/im1.png" alt="" />
                    <img class="two-img" src="./image/pc/im2.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="two-img" src="./image/pc/im5.png" alt="" />
                    <img class="two-img" src="./image/pc/im6.png" alt="" />
                  </div>
                  <div class="im-column-item">
                    <img class="one-img" src="./image/pc/im4.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <ul class="select-item-pagination"></ul>
            <img class="arrow arrow-prev" src="./image/pc/cont_arrow_left.png" />
            <img class="arrow arrow-next" src="./image/pc/cont_arrow_right.png" />
          </div>
          <!-- 直播 -->
          <!-- 视频 -->
          <!-- 语音 -->
        </div>
      </div>

      <!-- 应用场景 -->
      <div class="apply-scene" id="scroll4">
        <div class="sec-tit"><img class="img" src="./image/pc/sectit_apply_scene.png" alt="" /></div>
        <div class="apply-scene-desc">在画面呈现方式日渐成熟的基础下，叠加5G、算力、AI等技术能力的提升，其落地应用场景日渐丰富，不再限于虚拟形象塑造的应用，还在社交、游戏、办公等场景实现了真实人类虚拟化身的身份职能，并逐渐在直播电商、偶像造星、陪伴服务等 AI 虚拟数字人领域实现商业变现。</div>
        <div class="apply-swiper-wrap">
          <div class="swiper apply-scene-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide slide-wrap">
                <div class="slide-tit">面向B端市场</div>
                <div class="slide-item-wrap clearfix three">
                  <div class="slide-item">
                    <div class="hover-bg">
                      <div class="line-wrap"><div class="line"></div></div>
                    </div>
                    <div class="def-show">
                      <div class="num">01</div>
                      <div class="tit">数字员工</div>
                      <div class="desc">渗透企业生产链，在各种服务场景扮演各种不同角色。比如虚拟客服、虚拟导游、智能助手、虚拟讲师等角色。与企业的智能办公理念完美吻合，真正的为企业实现了降本提效。</div>
                    </div>
                  </div>
                  <div class="slide-item">
                    <div class="hover-bg">
                      <div class="line-wrap"><div class="line"></div></div>
                    </div>
                    <div class="def-show">
                      <div class="num">02</div>
                      <div class="tit">产品代言</div>
                      <div class="desc">明星代言，总是担心言行不可控制，还要冒人设翻车的风险。有了产品代言人，企业就找到了自己的掌控感，各种代言形态不再受约束。</div>
                    </div>
                  </div>
                  <div class="slide-item">
                    <div class="hover-bg">
                      <div class="line-wrap"><div class="line"></div></div>
                    </div>
                    <div class="def-show">
                      <div class="num">03</div>
                      <div class="tit">IP打造</div>
                      <div class="desc">打造企业专属IP，为内容生产赋能，让你的自媒体平台运营不再“卷”进去，让你在流量的世界获得更多圈粉。</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-slide slide-wrap">
                <div class="slide-tit">面向C端市场</div>
                <div class="slide-item-wrap clearfix">
                  <div class="slide-item">
                    <div class="hover-bg">
                      <div class="line-wrap"><div class="line"></div></div>
                    </div>
                    <div class="def-show">
                      <div class="num">01</div>
                      <div class="tit">娱乐型数字人</div>
                      <div class="desc">利用虚拟偶像来撬动娱乐游戏的蛋糕，已成为当下的一个风口。由超视界影视为你保驾护航，一定会助力你站稳这个最炙热的风口。</div>
                    </div>
                  </div>
                  <div class="slide-item">
                    <div class="hover-bg">
                      <div class="line-wrap"><div class="line"></div></div>
                    </div>
                    <div class="def-show">
                      <div class="num">02</div>
                      <div class="tit">数字KOL</div>
                      <div class="desc">在万物互联的元宇宙时代，个人的数字人身份当然也是不可或缺的。超视界影视完全可以按照个人的需求，量身打造你的数字人专属身份。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul class="apply-scene-pagination"></ul>
        </div>
      </div>

      <!-- 数字人由来 -->
      <div class="only-pic"><img class="img" src="./image/pc/bg04.png" alt="" /></div>

      <!-- 数字人发展历程 -->
      <div class="only-pic" id="scroll5"><img class="img" src="./image/pc/bg05.png" alt="" /></div>

      <!-- 咨询服务 -->
      <div class="contact" id="scroll6">
        <div class="sec-tit"><img class="img" src="./image/pc/sectit_contact.png" alt="" /></div>
        <div class="contact-wrap">
          <div class="clearfix">
            <div class="left-info">
              <div class="info-item">
                <div class="info-tit">姓名</div>
                <input class="info-ipt" maxlength="10" v-model="userName"  type="text" placeholder="请输入姓名/称呼" />
              </div>
              <div class="info-item">
                <div class="info-tit">邮件</div>
                <input class="info-ipt"  maxlength="20" v-model="email" type="email" placeholder="请留下您的邮箱" />
              </div>
              <div class="info-item">
                <div class="info-tit">电话</div>
                <input class="info-ipt"  maxlength="11" v-model="phone" type="text" placeholder="请输入手机/电话" />
              </div>
            </div>
            <div class="right-desc">
              <div class="info-item">
                <div class="info-tit">请简单描述您需要咨询的问题</div>
                <textarea class="info-ipt textarea"  maxlength="200"  v-model="feedbackContent" type="text" placeholder="提交后工作人员将及时回复"></textarea>
              </div>
            </div>
          </div>
          <div class="submit-btn" @click="commitFeedBack()">提&nbsp;&nbsp;&nbsp;&nbsp;交</div>
        </div>
      </div>
    </div>

    <!-- 移动 -->
    <div class="m-wrap" v-else :style="{paddingTop: isMobile ? '1.2rem' : '0'}">
      <div class="m_logo-menu">
        <h1 class="logo"><router-link to="/"><img class="logo-img" src="./image/m/m_logo.png" alt="" /></router-link></h1>
        <!-- <img class="menu-btn" src="./image/m/m_menu_btn.png" /> -->
      </div>

      <div class="m_banner-wrap">
        <img class="banner" src="./image/m/m_banner.png" alt="" />
        <div class="btns">
          <div class="btn bot-cont">业务咨询</div>
          <!-- <div class="btn white">在线咨询</div> -->
        </div>
      </div>

      <div class="m_long-wrap">
        <div class="m_one-site">
          <div class="title">一站式打造品牌虚拟数字资产</div>
          <div class="desc">超视界影视传媒在优化整合自有资源、发挥快速动画制作技术优势的基础上，全力打造出具有全场景、一站式、平台化特点的全链路定制服务模式，能满足从基础数字人形象设计、人设管理再到业务编排、内容创作，最后到多种驱动模式下与用户互动的全部需求。 </div>
          <div class="swiper m_one-site-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide m_site-item"><img class="img" src="./image/m/m_step1.png" alt="" /></div>
              <div class="swiper-slide m_site-item"><img class="img" src="./image/m/m_step2.png" alt="" /></div>
              <div class="swiper-slide m_site-item"><img class="img" src="./image/m/m_step3.png" alt="" /></div>
              <div class="swiper-slide m_site-item"><img class="img" src="./image/m/m_step4.png" alt="" /></div>
              <div class="swiper-slide m_site-item"><img class="img" src="./image/m/m_step5.png" alt="" /></div>
              <div class="swiper-slide m_site-item"><img class="img" src="./image/m/m_step6.png" alt="" /></div>
              <div class="swiper-slide m_site-item"><img class="img" src="./image/m/m_step7.png" alt="" /></div>
            </div>
          </div>
        </div>
        <div class="m_ai-types">
          <img class="m_sec-tit" src="./image/m/m_sectit1.png" />
          <div class="type-list">
            <img class="type-item" src="./image/m/type1.png" alt="" />
            <img class="type-item" src="./image/m/type2.png" alt="" />
            <img class="type-item" src="./image/m/type3.png" alt="" />
            <img class="type-item" src="./image/m/type4.png" alt="" />
            <img class="type-item" src="./image/m/type5.png" alt="" />
          </div>
        </div>
        <div class="m_pro-cont">
          <img class="m_sec-tit" src="./image/m/m_sectit2.png" />
          <div class="cont-select clearfix">
            <div class="cont-itm">
              <img class="cont-itm-img" src="./image/m/select_tab1.png" alt="" />
              <div class="cont-itm-tit">图片</div>
            </div>
            <div class="cont-itm">
              <img class="cont-itm-img" src="./image/m/select_tab2.png" alt="" />
              <div class="cont-itm-tit">直播</div>
            </div>
            <div class="cont-itm">
              <img class="cont-itm-img" src="./image/m/select_tab3.png" alt="" />
              <div class="cont-itm-tit">视频</div>
            </div>
            <div class="cont-itm">
              <img class="cont-itm-img" src="./image/m/select_tab4.png" alt="" />
              <div class="cont-itm-tit">语音</div>
            </div>
          </div>
          <div class="swiper cont-pics">
            <div class="swiper-wrapper">
              <div class="swiper-slide clearfix">
                <div class="left">
                  <img class="two-img" src="./image/m/m_pro3.png" alt="" />
                </div>
                <div class="right">
                  <img class="one-img" src="./image/m/m_pro1.png" alt="" />
                  <img class="one-img" src="./image/m/m_pro2.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide clearfix">
                <div class="left">
                  <img class="one-img" src="./image/m/m_pro5.png" alt="" />
                  <img class="one-img" src="./image/m/m_pro6.png" alt="" />
                </div>
                <div class="right">
                  <img class="two-img" src="./image/m/m_pro4.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="m_apply-scene">
        <img class="m_sec-tit" src="./image/m/m_sectit3.png" />
        <div class="desc">在画面呈现方式日渐成熟的基础下，叠加5G、算力、AI等技术能力的提升，其落地应用场景日渐丰富，不再限于虚拟形象塑造的应用，还在社交、游戏、办公等场景实现了真实人类虚拟化身的身份职能，并逐渐在直播电商、偶像造星、陪伴服务等 AI 虚拟数字人领域实现商业变现。</div>
        <div class="apply-wrap">
          <div class="title">面向B端市场</div>
          <div class="apply-item">
            <div class="num">01</div>
            <div class="tit">数字员工</div>
            <div class="cont">渗透企业生产链，在各种服务场景扮演各种不同角色。比如虚拟客服、虚拟导游、智能助手、虚拟讲师等角色。与企业的智能办公理念完美吻合，真正的为企业实现了降本提效。</div>
          </div>
          <div class="apply-item">
            <div class="num">02</div>
            <div class="tit">产品代言</div>
            <div class="cont">明星代言，总是担心言行不可控制，还要冒人设翻车的风险。有了产品代言人，企业就找到了自己的掌控感，各种代言形态不再受约束。</div>
          </div>
          <div class="apply-item">
            <div class="num">03</div>
            <div class="tit">IP打造</div>
            <div class="cont">打造企业专属IP，为内容生产赋能，让你的自媒体平台运营不再“卷”进去，让你在流量的世界获得更多圈粉。</div>
          </div>
        </div>
        <div class="apply-wrap">
          <div class="title">面向C端市场</div>
          <div class="apply-item">
            <div class="num">01</div>
            <div class="tit">娱乐型数字人</div>
            <div class="cont">利用虚拟偶像来撬动娱乐游戏的蛋糕，已成为当下的一个风口。由超视界影视为你保驾护航，一定会助力你站稳这个最炙热的风口。</div>
          </div>
          <div class="apply-item">
            <div class="num">02</div>
            <div class="tit">数字KOL</div>
            <div class="cont">在万物互联的元宇宙时代，个人的数字人身份当然也是不可或缺的。超视界影视完全可以按照个人的需求，量身打造你的数字人专属身份。</div>
          </div>
        </div>
      </div>

      <!-- 数字人由来 -->
      <div class="m_common-img"><img class="img" src="./image/m/m_ai_from.png" alt="" /></div>

      <!-- 数字人发展历程 -->
      <div class="m_common-img"><img class="img" src="./image/m/m_ai_progress.png" alt="" /></div>

      <!-- 咨询服务 -->
      <div class="m_contact" id="scroll-m">
        <img class="m_sec-tit" src="./image/m/m_sectit4.png" />
        <div class="edit-wrap">
          <div class="edit-item">
            <div class="tit">姓名</div>
            <input class="ipt" maxlength="10" v-model="userName"   type="text" placeholder="请输入姓名/称呼" />
          </div>
          <div class="edit-item">
            <div class="tit">邮件</div>
            <input class="ipt"  maxlength="20" v-model="email" type="text" placeholder="请留下您的邮箱" />
          </div>
          <div class="edit-item">
            <div class="tit">电话</div>
            <input class="ipt" type="text" maxlength="11" v-model="phone" placeholder="请输入手机/电话" />
          </div>
          <div class="edit-item more-line">
            <div class="tit">请简单描述您需要咨询的问题</div>
            <textarea class="ipt" type="text"   maxlength="200"  v-model="feedbackContent" placeholder="提交后工作人员将及时回复"></textarea>
          </div>
          <div class="submit-btn" @click="commitFeedBack()" >提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import "./js/swiper-bundle.min.js"

  export default {
    name: 'aiIndex',
    data () {
      return {
        userName:"",
        email:"",
        phone:"",
        feedbackContent:""
      }
    },
    mounted () {
      this.windowResize()
      window.addEventListener('resize', this.windowResize, false)
      this.init()
    },
    beforeDestroy () {
      document.documentElement.style = ''
    },
    computed: {
      isMobile () {
        var userAgentInfo = navigator.userAgent;
        var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        var mobile_flag = false;

        //根据userAgent判断是否是手机
        for (var v = 0; v < mobileAgents.length; v++) {
          if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
            mobile_flag = true;
            break;
          }
        }
        var screen_width = window.screen.width;
        var screen_height = window.screen.height;

        //根据屏幕分辨率判断是否是手机
        if (screen_width > 325 && screen_height < 750) {
          mobile_flag = true;
        }

        return mobile_flag;
      }
    },
    methods: {
      init () {
        if(this.isMobile){
          this.initMEvent()
        }else {
          this.initPcEvent()
        }
      },
      commitFeedBack(){
        let _this=this;
        if(!this.userName){
          _this.$message({
            message: '姓名不能为空',
            type: 'warning'
          });
          return false;
        }
        if(!this.email){
          _this.$message({
            message: '邮箱不能为空',
            type: 'warning'
          });
          return false;
        }
        const emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!emailReg.test(this.email)) {
          _this.$message({
            message: '邮箱格式有误',
            type: 'warning'
          });
          return false;
        }
        if(!this.phone){
          _this.$message({
            message: '电话不能为空',
            type: 'warning'
          });
          return false;
        }
        const reg = /^1[1|2|3|4|5|6|7|8|9][0-9]\d{8}$/
        if (!reg.test(this.phone)) {
          _this.$message({
            message: '手机号码格式有误',
            type: 'warning'
          });
          return false;
        }
        if(!this.feedbackContent){
          _this.$message({
            message: '问题不能为空',
            type: 'warning'
          });
          return false;
        }
        let formData = new FormData();
        formData.append("userName", this.userName);
        formData.append("contactWay", this.phone+";"+this.email);
        formData.append("feedbackContent", this.feedbackContent);

        _this.$axios.post("/rrbi/feedback/addAnonymousFeedback" , formData ,{
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(resp){
            alert("您已提交成功");
            location.reload();
        }).catch(function (error) {
        })

      },
      windowResize () {
        let x = this.isMobile ? 7.5 : 19.2
        document.documentElement.style.fontSize = document.documentElement.clientWidth / x + 'px'
      },
      initPcEvent () {
        // 根据滚动高度判断是否给菜单添加背景
        $(window).scroll(function () {
          var scrollTop = $(window).scrollTop()
          var maxTop = $('#scroll1').offset().top
          if(scrollTop > maxTop - 5){
            $('.logo-menu').css({
              backgroundImage: 'linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, 0))'
            })
          }else{
            $('.logo-menu').css({
              background: 'none'
            })
          }
        })

        // 菜单点击
        $('.logo-menu .menu .menu-tit').click(function () {
          $('html, body').animate({
            scrollTop: $('#scroll' + ($(this).index() + 1)).offset().top
          }, 500)
        })

        // 试用申请
        $('.top-banner .btns .btn.con-bot').click(function () {
          $('html, body').animate({
            scrollTop: $('#scroll6').offset().top
          }, 500)
        })

        // 一站式打造品牌虚拟数字资产
        new Swiper(".site-container", {
          simulateTouch: false, // 禁止鼠标模拟
          slidesPerView: "auto", // 设置slider容器能够同时显示的slides数量(carousel模式)
          spaceBetween: 20, // 在slide之间设置距离
          loop: true, // 循环(loop)模式
          autoplay: {
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          },
          navigation: {
            nextEl: ".site-control .next",
            prevEl: ".site-control .prev",
          },
        })

        // 虚拟数字人类型
        new Swiper(".types-wrap", {
          simulateTouch: false, // 禁止鼠标模拟
          direction: "vertical", // 垂直轮播
          autoplay: {
            delay: 5000, // 自动切换的时间间隔
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          },
          pagination: {
            el: ".types-list .tp-list",
            clickable: true,
            bulletClass: 'tp-itm',
            bulletActiveClass: 'active',
            renderBullet: function (index, className) {
              const types = ['超写实角色', '三维美型角色', '2.5次元角色', '二次元角色', '卡通角色']
              return `
                <div class="${className}">
                  <p>
                    <span class="num">${'0' + (index + 1)}</span>
                    <span class="tp-tit">${types[index]}</span>
                  </p>
                </div>
              `;
            },
          }
        })

        // 内容生产
        new Swiper('.cont-select-item', {
          simulateTouch: false, // 禁止鼠标模拟
          loop: true,
          autoplay: {
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          },
          pagination: {
            el: ".select-item-pagination",
            clickable: true,
            bulletClass: 'pagin-item',
            bulletActiveClass: 'active',
            renderBullet: function (index, className) {
              return `<li class="${className}"></li>`;
            },
          },
          navigation: {
            nextEl: ".wrap-container .arrow-next",
            prevEl: ".wrap-container .arrow-prev",
          },
        })

        // 应用场景
        new Swiper(".apply-scene-swiper", {
          simulateTouch: false, // 禁止鼠标模拟
          autoplay: true,
          loop: true,
          pagination: {
            el: '.apply-scene-pagination',
            clickable: true,
            bulletClass: 'itm',
            bulletActiveClass: 'active',
            renderBullet: function (index, className) {
              return `<li class="${className}"></li>`;
            }
          }
        });

        $('.slide-item-wrap .slide-item').hover(function () {
          $(this).find('.hover-bg').stop().animate({height: '100%'})
          $(this).find('.hover-bg .line').stop().animate({width: '60%'})
          $(this).find('.hover-bg').addClass('arrow')
        }, function () {
          $(this).find('.hover-bg').stop().animate({height: '0'})
          $(this).find('.hover-bg .line').stop().animate({width: '0'})
          $(this).find('.hover-bg').removeClass('arrow')
        })
      },
      initMEvent () {
        // 试用申请
        $('.m_banner-wrap .btn.bot-cont').click(function () {
          $('html, body').animate({
            scrollTop: $('#scroll-m').offset().top
          }, 500)
        })
        // 移动端一站式
        new Swiper(".m_one-site-swiper", {
          slidesPerView: "auto",
          spaceBetween: 20,
          loop: true,
          autoplay: {
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          },
        })
        new Swiper(".m_pro-cont .cont-pics", {
          loop: true,
          autoplay: {
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          },
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "./style/swiper-bundle.min.css";
  @import "./style/pc.css";
  @import "./style/m.css";
</style>
